import i18n from '../language/index'
import { getToken } from './cookie'
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'

const DEFAULT_DOMAIN = 'http://client.71360.com'
var domainFullUrl = ''
function changeDataType(obj) {
  let str = ''
  if (typeof obj === 'object') {
    for (const i in obj) {
      if (typeof obj[i] !== 'function' && typeof obj[i] !== 'object') {
        str += i + '=' + obj[i] + '&'
      } else if (typeof obj[i] === 'object') {
        nextStr = ''
        str += changeSonType(i, obj[i])
      }
    }
  }
  return str.replace(/&$/g, '')
}

function changeSonType(objName, objValue) {
  if (typeof objValue === 'object') {
    for (const i in objValue) {
      if (typeof objValue[i] !== 'object') {
        const value = objName + '[' + i + ']=' + objValue[i]
        nextStr += encodeURI(value) + '&'
      } else {
        changeSonType(objName + '[' + i + ']', objValue[i])
      }
    }
  }
  return nextStr
}

class Global {
  constructor(name) {
    this.name = name
  }
  getImgUrl(id) {
    return `${process.env.VUE_APP_BASE_API}/tcloud-fs/fs/readImage?fileId=${id}&X-Token=${getToken()}`
  }
  dateFormate(date) {
    let month = date.getMonth()
    let day = date.getDate()

    if (month < 9) {
      month = '0' + (month + 1)
    } else {
      month = month + 1
    }
    if (day < 10) {
      day = '0' + day
    }
    return date.getFullYear() + '-' + month + '-' + day
  }
  getApiUrl() {
    var url = DEFAULT_DOMAIN

    if (domainFullUrl != '') {
      url = domainFullUrl
    } else if (window.CefJS) {
      domainFullUrl = CefJS.getDomainUrl()
      if (domainFullUrl) { url = domainFullUrl }
    }

    return url
  }
  tyunPost(url, postData) {
    var postUrl = this.getApiUrl() + url

    postData = this.addTicketInfo(postData)

    var ticketInfo = {}

    if (window.CefJS) { ticketInfo = JSON.parse(CefJS.getTicketInfo()) }

    return axios({
      url: postUrl,
      method: 'POST',
      // data: $.param(postData),
      data: changeDataType(postData),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        // dev环境注释掉其他头部信息 不然post会变成options请求
        // 'Ticket': ticketInfo.Ticket,
        // 'Timestamp': ticketInfo.Timestamp,
        // 'Token': ticketInfo.Token,
        // 'AppVersion': ticketInfo.AppVersion,
        // 'ServerVersion': ticketInfo.ServerVersion
      }
    })
  }
  getUploadUrl() {
    return this.getApiUrl()
  }
  addTicketInfo(postData) {
    var ticketInfo = this.getTicketInfo()

    if (!postData) postData = {}

    postData.ticket = ticketInfo.Ticket

    // postData.timestamp = ticketInfo.Timestamp;

    // postData.token = ticketInfo.Token;

    return postData
  }
  getTicketInfo() {
    var ticketInfo = {}

    if (window.CefJS) { ticketInfo = JSON.parse(CefJS.getTicketInfo()) }

    // 请在这里填写你的测试票据信息
    var devTicket = '22222222-df14-49be-a58a-63edb0b96d75'

    ticketInfo.Ticket = ticketInfo.Ticket ? ticketInfo.Ticket : devTicket

    return ticketInfo
  }
  openMessageBox(message, type = 'error', onCloseMethod = null) {
    return Message({
      message: message,
      showClose: true,
      type: type,
      onClose: onCloseMethod,
      duration: 2000
    })
  }
  openConfirmBox(message, type = 'warning', title = i18n.t('view_public_topbar_23')) {
    var myMessageBtn = getButtonColor()
    return MessageBox.confirm(message, title, {
      confirmButtonText: i18n.t('view_public_topbar_24'),
      cancelButtonText: i18n.t('view_public_topbar_11'),
      cancelButtonClass: myMessageBtn.cancel,
      confirmButtonClass: myMessageBtn.confirm,
      type: type
    })
  }
  openAlertBox(message, type = 'info', title = i18n.t('view_public_topbar_23')) {
    var myMessageBtn = getButtonColor()
    return MessageBox.alert(message, title, {
      confirmButtonText: i18n.t('view_public_topbar_24'),
      confirmButtonClass: myMessageBtn.confirm,
      type: type
    })
  }
  parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') return [i18n.t('base_global_686'), i18n.t('base_global_687'), i18n.t('base_global_688'), i18n.t('base_global_689'), i18n.t('base_global_690'), i18n.t('base_global_691'), i18n.t('base_global_692')][value - 1]
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  }
  // 获取本周
  getStartWeek() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const mondayTime = now.getTime() - (now.getDay() - 1) * oneDayLong
    const monday = new Date(mondayTime)
    var start = this.dateFormate(monday)
    return start
  }
  getEndWeek() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const sundayTime = now.getTime() + (7 - now.getDay()) * oneDayLong
    const sunday = new Date(sundayTime)
    var end = this.dateFormate(sunday)
    return end
  }
  /**
   *获得本月的开始日期和结束日期
   */
  getStartMonth() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const year = now.getFullYear()
    const monthStartDate = new Date(year, now.getMonth(), 1)// 当前月1号
    var start = this.dateFormate(monthStartDate)
    return start
  }
  getEndMonth() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const year = now.getFullYear()
    const monthStartDate = new Date(year, now.getMonth(), 1)// 当前月1号
    const nextMonthStartDate = new Date(year, now.getMonth() + 1, 1)// 下个月1号
    const days = (nextMonthStartDate.getTime() - monthStartDate.getTime()) / oneDayLong// 计算当前月份的天数
    const monthEndDate = new Date(year, now.getMonth(), days)
    var End = this.dateFormate(monthEndDate)
    return End
  }
}
export default Global

/*
* 获取最近几天日期 getDay(0);//当天日期 getDay(-7);//7天前日期 getDay(3);//3天后日期
*
* */
export function getDay(day) {
  const today = new Date()
  const targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
  today.setTime(targetday_milliseconds) // 注意，这行是关键代码

  const tYear = today.getFullYear()
  let tMonth = today.getMonth()
  let tDate = today.getDate()
  tMonth = doHandleMonth(tMonth + 1)
  tDate = doHandleMonth(tDate)
  return tYear + '-' + tMonth + '-' + tDate
}

function doHandleMonth(month) {
  var m = month
  if (month.toString().length === 1) {
    m = '0' + month
  }
  return m
}

/**
 * 计算2个日期相差的天数，不包含今天，如：2016-12-13到2016-12-15，相差2天
 * @param startDateString
 * @param endDateString
 * @returns
 */
export function dateDiff(startDateString, endDateString) {
  var separator = '-' // 日期分隔符
  var startDates = startDateString.split(separator)
  var endDates = endDateString.split(separator)
  var startDate = new Date(startDates[0], startDates[1] - 1, startDates[2])
  var endDate = new Date(endDates[0], endDates[1] - 1, endDates[2])
  return parseInt(Math.abs(endDate - startDate) / 1000 / 60 / 60 / 24)// 把相差的毫秒数转换为天数
}

/**
 * 本月、上月、下月的起始、结束日期
 * getMonth(type,months)  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，months为数字类型，不传或0代表本月，-1代表上月，1代表下月
 * getMonth("s",1)  //得到下月第一天的yyyy-mm-dd格式日期
 * getMonth("e",1)  //得到下月最后一天的yyyy-mm-dd格式日期
 */
export function getMonthStartAndEndDate(type, months) {
  var d = new Date()
  var year = d.getFullYear()
  var month = d.getMonth() + 1
  if (Math.abs(months) > 12) {
    months = months % 12
  }
  if (months !== 0) {
    if (month + months > 12) {
      year++
      month = (month + months) % 12
    } else if (month + months < 1) {
      year--
      month = 12 + month + months
    } else {
      month = month + months
    }
  }
  month = month < 10 ? '0' + month : month
  var date = d.getDate()
  var firstday = year + '-' + month + '-' + '01'
  var lastday = ''
  if (month === '01' || month === '03' || month === '05' || month === '07' || month === '08' || month === '10' || month === '12') {
    lastday = year + '-' + month + '-' + 31
  } else if (month === '02') {
    if ((year % 4 === 0 && year % 100 !== 0) || (year % 100 === 0 && year % 400 === 0)) {
      lastday = year + '-' + month + '-' + 29
    } else {
      lastday = year + '-' + month + '-' + 28
    }
  } else {
    lastday = year + '-' + month + '-' + 30
  }
  var day = ''
  if (type === 's') {
    day = firstday
  } else {
    day = lastday
  }
  return day
}
/* 时时间戳转为字符串*/
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return [i18n.t('base_global_686'), i18n.t('base_global_687'), i18n.t('base_global_688'), i18n.t('base_global_689'), i18n.t('base_global_690'), i18n.t('base_global_691'), i18n.t('base_global_692')][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}




// WEBPACK FOOTER //
// ./src/base/global.js